import React from 'react';
import './CasePost.css';
import adminImg from '../../../Asset/contact-img.jpeg';
import img1 from '../../../Asset/case-study/image-1.png';
import img2 from '../../../Asset/case-study/image-2.png';
import img3 from '../../../Asset/case-study/image-3.png';
import img4 from '../../../Asset/case-study/image-4.png';
import img5 from '../../../Asset/case-study/image-5.png';
import img6 from '../../../Asset/case-study/image-6.png';
import img7 from '../../../Asset/case-study/image-7.png';

const CasePost = () => {
    return (
        <div className="casePost-root container">
           <div className="row d-flex justify-content-between">
               <div className="col-md-8 col-sm-12 main-content">
               <h1>Redesigning the New York Times <br/> app — a UX case stud</h1>
            <div className="post-timer d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                    <img height="34px" src={adminImg} alt=""/>
                    <p className="pt-3 ml-4">Forhad Sheikh // Mar 14, 2020</p>
                </div>
                <i class="fa fa-bookmark" aria-hidden="true"></i>
            </div>
            <div className="case-post-desc">
                <p>Brief: Timely provide to quick read articles from 2–5 mins. News catered to specific users based on their schedule and habits..</p>
            </div>
            <div className="set">
           <div className="d-flex align-items-center">
           <span>01</span><h2> The Problem</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.<br/>
1. Coverage (Users are unhappy about something they read)<br/>
2. Life-changing event (moving).<br/>
3. Lack of usage.<br/>
4. Irrelevant content</p>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>02</span><h2>  Goal</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.<br/>
1. Coverage (Users are unhappy about something they read)<br/>
2. Life-changing event (moving).<br/>
3. Lack of usage.<br/>
4. Irrelevant content</p>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>03</span><h2> Design Process</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.</p>
                <img src={img1} alt=""/>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>05</span><h2> Design Process</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.<br/>
1. User Research<br/>
2. User Interview<br/>
3. Parsona<br/>
4. User Flow<br/>
5. Wareframe<br/>
6. UI Design<br/>
7. User Testing
</p>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>04</span><h2>  My role and team</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.<br/>
1. User Research<br/>
2. User Interview<br/>
3. Parsona<br/>
4. User Flow<br/>
5. Wareframe<br/>
6. UI Design<br/>
7. User Testing

</p>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>06</span><h2> User Interview Question</h2>
           </div>
                <p>1. User Research<br/>
2. User Interview<br/>
3. Parsona<br/>
4. User Flow<br/>
5. Wareframe<br/>
6. UI Design<br/>
7. User Testing
</p>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>07</span><h2> Personas</h2>
           </div>
                <p>The New York Times app loses the love of users, due to a myriad of reasons. Along with the competition and cost, the following factors are the reasons for the difficulties.<br/>
1. User Research<br/>
2. User Interview<br/>
3. Parsona<br/>
4. User Flow<br/>
5. Wareframe<br/>
6. UI Design<br/>
7. User Testing
</p>
                <img src={img2} alt=""/>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>08</span><h2> Empathy Maping</h2>
           </div>
                <p>Next, I scripted a typical daily feeding routine for my persona. This process helped me decide how the app’s user experience might be designed to fit in with a feeding routine.
</p>
                <img src={img3} alt=""/>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>07</span><h2> User Journey Map</h2>
           </div>
                <p>Next, I scripted a typical daily feeding routine for my persona. This process helped me decide how the app’s user experience might be designed to fit in with a feeding routine.</p>
                <img src={img4} alt=""/>
            </div>

            <div className="set">
           <div className="d-flex align-items-center">
           <span>08</span><h2> User Task Flow</h2>
           </div>
                <p>Next, I scripted a typical daily feeding routine for my persona. This process helped me decide how the app’s user experience might be designed to fit in with a feeding routine.</p>
                <img src={img5} alt=""/>
            </div>
            <div className="set">
           <div className="d-flex align-items-center">
           <span>09</span><h2> Information Architecture</h2>
           </div>
                <img src={img6} alt=""/>
            </div>
            <div className="set">
           <div className="d-flex align-items-center">
           <span>10</span><h2> Waremrame</h2>
           </div>
                <p>Next, I scripted a typical daily feeding routine for my persona. This process helped me decide how the app’s user experience might be designed to fit in with a feeding routine.</p>
                <img src={img7} alt=""/>
            </div>
            <div className="set">
           <div className="d-flex align-items-center">
           <span>10</span><h2> Waremrame</h2>
           </div>
                <p>Next, I scripted a typical daily feeding routine for my persona. This process helped me decide how the app’s user experience might be designed to fit in with a feeding routine.</p>
                <img src={img7} alt=""/>
            </div>
               </div>
               <div className="col-md-3 col-sm-12 side-bar">
                    <h3>RELATED CASE STUDY</h3>
                    <div className="case-card " id="side-case-card">
                        <div className="case-img" id="side-case-img">

                        </div>
                        <div className="case-info p-2">
                            <h5><span className="text-c-green">Branding bite,</span> UI Design</h5>
                            <p>I currently am the lead designer on the user interface design team for visualizer.</p>
                            <button>VIEW MY ROLL</button>
                        </div>
                    </div>
                    <div className="case-card " id="side-case-card">
                        <div className="case-img" id="side-case-img">

                        </div>
                        <div className="case-info p-2">
                            <h5><span className="text-c-green">Branding bite,</span> UI Design</h5>
                            <p>I currently am the lead designer on the user interface design team for visualizer.</p>
                            <button>VIEW MY ROLL</button>
                        </div>
                    </div>
               </div>
           </div>
        </div>
    );
};

export default CasePost;